import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const CalendarWeekTimeGrid = ({
  cellWidth = 150,
  hourHeight = 80,
  hideWeekends = false,
  startHour = 8,
  endHour = 20,
}) => {
  const numHours = endHour - startHour;
  const hours = Array.from({ length: numHours}, (_, i) => startHour + i);
  const numCols = hideWeekends ? 5 : 7;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
      }}
    >
      {hours.map((hour) => (
        <Box
          key={hour}
          sx={{
            display: 'flex',
            height: hourHeight,
            borderBottom: 1,
            borderColor: 'divider',
            width: cellWidth * ((hideWeekends ? 5 : 7) + 1),
          }}
        >
          <Box
            style={{
              width: cellWidth,
              paddingLeft: '1em',
            }}
            sx={{
              // width: cellWidth,
              flexShrink: 0,
              borderRight: 1,
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              pl: 1,
              pt: 0.25,
            }}
          >
            <Typography 
              variant="caption" 
              fontWeight={600}
              style={{color: 'rgb(140,140,140)'}}
            >
              {hour === 0 ? '12' : hour > 12 ? hour - 12 : hour}{':00'}
              {' '}{hour < 12 ? 'AM' : 'PM'}
            </Typography>
          </Box>
          {Array.from({ length: numCols }).map((_, colIndex) => (
            <Box
              key={colIndex}
              sx={{
                width: cellWidth,
                flexShrink: 0,
                borderRight: 1,
                borderColor: 'divider',
              }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default CalendarWeekTimeGrid;
